import { CountryCode } from '~Types';

/** Special keys, carried in `data-key` next to the plain characters. */
export const BACKSPACE = 'backspace';
export const SPACE = 'space';

/** A–Z 0–9 in QWERTY order - what the shopper expects from a phone. */
const BASE_ROWS: string[][] = [
  '1234567890'.split(''),
  'QWERTYUIOP'.split(''),
  'ASDFGHJKL'.split(''),
  'ZXCVBNM'.split(''),
];

/** Letters a country adds after P (row 2) and after L (row 3), in its own keyboard order. */
const EXTRA_LETTERS: Partial<Record<CountryCode, [string[], string[]]>> = {
  SE: [['Å'], ['Ö', 'Ä']],
  NO: [['Å'], ['Ø', 'Æ']],
  DK: [['Å'], ['Æ', 'Ø']],
  ES: [[], ['Ñ']],
  GB: [[], []],
};

/** Falls back to Sweden when the company has no country or one without a layout of its own. */
const DEFAULT_COUNTRY: CountryCode = 'SE';

/** The key rows for a country, backspace at the end of the last row. */
export const rowsForCountry = (country: CountryCode | null): string[][] => {
  const extras = EXTRA_LETTERS[country ?? DEFAULT_COUNTRY] ?? EXTRA_LETTERS[DEFAULT_COUNTRY]!;
  return [
    BASE_ROWS[0],
    [...BASE_ROWS[1], ...extras[0]],
    [...BASE_ROWS[2], ...extras[1]],
    [...BASE_ROWS[3], BACKSPACE],
  ];
};
